<template>
  <div class="time-slider-wrapper">
    <div v-if="enabled" class="time-slider">
      <div class="wrapper">
        <!-- <select-comp-wrapper
          v-model="internalDropdownValue"
          :options="timeOptions"
          :multiple="false"
          :can-bold="false"
          :can-chart="false"
        /> -->
        <div class="min">{{ min }}</div>
        <div ref="root" class="root" />
        <div class="max">{{ max }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { select as d3_select, pointer as d3_pointer } from 'd3-selection'
import { scaleTime as d3_scaleTime } from 'd3-scale'
import { drag as d3_drag } from 'd3-drag'
import Size from '@/mixins/Size'
// import SelectCompWrapper from '@/components/table/SelectCompWrapper.vue'
export default {
  // components: { SelectCompWrapper },
  mixins: [Size],
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: ['pivotConfig', 'dimensionMetas', 'options'],
  data() {
    return {
      currentHover: null,
      playing: false,
      changeTimer: null,
    }
  },
  computed: {
    internalPivotConfig: {
      get() {
        return JSON.parse(JSON.stringify(this.pivotConfig))
      },
      set(v) {
        this.$emit('change', v)
      },
    },
    // internalDropdownValue: {
    //   get() {
    //     return [this.internalValue]
    //   },
    //   set(selection) {
    //     this.internalValue = selection[0]
    //   },
    // },
    internalValue: {
      get() {
        return this.timeDim.values[0]
      },
      set(value) {
        clearTimeout(this.changeTimer)
        this.changeTimer = setTimeout(() => {
          this.timeDim.values = [value]
          this.timeTypeDim.values = [
            this.optToValue(
              this.dimensionMetas[this.timeDim.id].typeOptions.find(t => t.id === value.type)
            ),
          ]
          this.internalPivotConfig = { ...this.internalPivotConfig }
        }, 200)
      },
    },
    min() {
      return this.timeOptions[0].label
    },
    max() {
      return this.timeOptions[this.timeOptions.length - 1].label
    },
    timeDim() {
      return this.internalPivotConfig.dimensions.find(d => {
        return this.dimensionMetas[d.id]?.type === 'time'
      })
    },
    timeTypeDim() {
      return this.internalPivotConfig.dimensions.find(d => {
        return d.id === this.timeDim.id + '_type'
      })
    },
    enabled() {
      return (
        this.timeDim &&
        (this.timeDim.role === 'filters' || this.timeDim.role === 'columns') &&
        this.timeOptions.length > 1
      )
    },
    timeOptions() {
      let currentType = this.timeTypeDim.values[0].value
      return this.options[this.timeDim.id].filter(o => o.type && o.type === currentType)
    },
  },
  watch: {
    size() {
      this.draw()
    },
    timeOptions() {
      this.draw()
    },
    internalValue(v, prev) {
      // de poco sirve...
      if (v.value !== prev.value) {
        let allOptions = this.options[this.timeDim.id]
        let prevOpt = allOptions.find(to => to.id === prev.value)
        let newOpt = allOptions.find(to => to.id === v.value)
        if (prevOpt.timeValue !== newOpt.timeValue) {
          this.updateHandle(newOpt)
        }
      }
    },
  },
  mounted() {
    this.draw()
  },
  methods: {
    draw() {
      if (!this.$refs.root) return
      this.root = d3_select(this.$refs.root)

      // this.root.attr('width', w).attr('height', this.size.height)
      let line = this.root.selectAll('.line').data([null])
      line = line.merge(line.enter().append('div').attr('class', 'line'))
      line.style('transform', `translate(0,0)`)
      this.scale = d3_scaleTime()
      this.scale
        .domain([
          this.timeOptions[0].timeValue,
          this.timeOptions[this.timeOptions.length - 1].timeValue,
        ])
        .range([0, 100])

      //basruilla para el "primer tick"...
      // let tickData = [this.scale.domain()[0], ...this.scale.actuals(20)]
      let tickData = this.scale.ticks(5)
      let tickFormat = this.scale.tickFormat(5)
      let ticks = this.root.selectAll('.tick').data(tickData, d => d)
      let ticksEnter = ticks.enter().append('div').attr('class', 'tick')
      ticks.exit().remove()
      ticksEnter.append('div').attr('class', 'text')
      ticksEnter.append('div').attr('class', 'line')
      ticks = ticks.merge(ticksEnter)
      ticks.style('left', d => `${this.scale(d)}%`)
      // ticks.style('left', d => `${this.scale(d)}px`).style('transform', 'translate(-50%,0)')

      ticks.select('.text').text(d => tickFormat(d))

      let actualData = this.timeOptions
      let actuals = this.root.selectAll('.actual').data(actualData, d => d.id)
      let actualsEnter = actuals.enter().append('div').attr('class', 'actual')
      actuals.exit().remove()
      actuals = actuals.merge(actualsEnter)
      actuals.style('left', d => `${this.scale(d.timeValue)}%`)

      let handle = this.root.selectAll('.handle').data([null])
      let handleEnter = handle.enter().append('div').attr('class', 'handle')
      handleEnter.append('div').attr('class', 'tooltip')
      handleEnter.append('div').attr('class', 'circle')

      handle = handle.merge(handleEnter)
      handle.raise()

      this.updateHandle(this.timeOptions.find(to => to.id === this.internalValue.value))

      let w = this.$refs.root.getBoundingClientRect().width

      this.root.call(
        d3_drag()
          .on('start.interrupt', () => {
            w = this.$refs.root.getBoundingClientRect().width
            handle.interrupt()
          })
          .on('start', e => {
            e = e.sourceEvent?.touches ? e.sourceEvent.touches[0] : e
            this.pause()
            let point = d3_pointer(e, this.root.node())[0]
            let percent = (100 * point) / w
            let bestOption = this.getClosest(this.scale.invert(percent))
            this.internalValue = this.optToValue(bestOption)
            this.updateHandle(bestOption, { immediate: false })
          })
          .on('drag', e => {
            e = e.sourceEvent?.touches ? e.sourceEvent.touches[0] : e
            this.pause()
            let point = d3_pointer(e, this.root.node())[0]
            let percent = (100 * point) / w
            let bestOption = this.getClosest(this.scale.invert(percent))
            this.internalValue = this.optToValue(bestOption)
            this.updateHandle(bestOption, { immediate: true })
          })
      )
    },
    updateHandle(bestOption, opts) {
      if (!this.scale || !bestOption) return
      let handle = this.root.selectAll('.handle')
      handle.select('.tooltip').text(bestOption.label)
      handle
        .transition()
        .duration(opts?.immediate ? 0 : 400)
        .style('left', `${this.scale(bestOption.timeValue)}%`)
    },
    optToValue: o => {
      return {
        value: o.id,
        type: o.type,
      }
    },
    getClosest(date) {
      let bestOption = this.timeOptions.reduce(
        (best, o) => {
          let dist = Math.abs(o.timeValue.getTime() - date.getTime())
          if (best.dist > dist) {
            best = { ...o, dist }
          }
          return best
        },
        { dist: Infinity }
      )
      this.currentHover = bestOption
      return bestOption
    },
    pause() {
      this.playing = false
      clearTimeout(this.changeTimer)
      clearTimeout(this.playTimer)
    },
  },
}
</script>

<style lang="stylus" scoped>
.time-slider-wrapper
  z-index: 10

  .time-slider
    // min-height: 100px
    margin: vw(10px) 0

    // .dots
    // display: flex
    // align-items: center
    // overflow-y: auto
    // margin-bottom: vw(30px)
    // max-width: 85vw
    // gap: vw(10px)

    // .dot
    // m-font-size(16, 26)
    // width: vw(40px)
    // cursor: pointer

    // &:hover,
    // &.current
    // font-weight: bold

    // &.current
    // cursor: default
    .wrapper
      display: flex
      align-items: center

      .custom-dropdown
        display: none
        flex: 0 0 vw(100px)

      .min,
      .max
        m-font-size(16, 26)
        color: #000
        font-weight: 600

      >>> .root
        flex: 1 1 0%
        margin-right: vw(20px)
        margin-left: vw(20px)
        width: 100%
        height: vw(30px)
        transform: translate(0, 50%)

        .line
          margin-top: vw(-1px)
          width: 100%
          height: 1px
          background-color: $grey

        .tick
          position: absolute

          .text
            position: absolute
            top: 0
            color: $grey
            transform: translate(-50%, -150%)

          .line
            position: absolute
            top: 0
            width: 1px
            height: vw(20px)
            border-left: solid 1px $grey

        .actual
          position: absolute
          width: 1px
          height: vw(7px)
          background: $grey

        .handle
          $circle-size = vw(24px)
          $top = "calc(-100% - %s)" % $circle-size
          position: absolute

          // transition: transform 0.3s ease-in-out
          .circle
            position: absolute
            width: $circle-size
            height: $circle-size
            border-radius: 50%
            background-color: #000
            cursor: pointer
            transform: translate(-50%, -50%)

          .tooltip
            m-font-size(14, 20)
            position: absolute
            padding: vw(4px) vw(8px)
            width: max-content
            border-radius: 4px
            background-color: $grey-dark
            color: #fff
            transform: translate(-50%, $top)

            &:after
              m-triangle("down", $grey-dark, 6)
              bottom: vw(-5px)
              left: 50%
              transform: translateX(-50%)
</style>
